import React, { Component } from "react";

import img1 from "../../banners/bannerNosotros.webp";



import "./Banner3.css";


class Banner3 extends Component {
  render() {
    const { images, names } = this.props;

    return (
      <section >
        <img src={img1} alt="banco" className="img1" />
      </section>
    );
  }
}

export default Banner3;



